import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { usePrayCommentPublicationMutation } from '@/src/features/comment/services/usePrayCommentPublicationMutation'
import { usePrayCommentResponseMutation } from '@/src/features/comment/services/usePrayForCommentResponseMutation'
import { PrayScreen } from '@/src/features/pray/ui/screens/PrayScreen'
import { TEST_ID } from '@/src/general/constants/testId'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

type TPublicationCommentPrayScreenProps = {
  commentAuthor: string
  commentId: number
  publicationId: number
  responseId?: number
}

export const PublicationCommentPrayScreen = ({
  publicationId,
  commentAuthor,
  commentId,
  responseId,
}: TPublicationCommentPrayScreenProps): ReactNode => {
  const router = useRouter()
  const { routes } = useRoutes()
  const { t } = useTranslate()

  const navigateBack = () => {
    if (router.canDismiss()) {
      router.dismiss()
    } else {
      router.replace(routes.publicationById({ id: publicationId, source: TRACKING_SOURCE.COMMENT }))
    }
  }

  const { mutate: prayCommentMutate } = usePrayCommentPublicationMutation(publicationId)
  const { mutate: prayCommentResponseMutate } = usePrayCommentResponseMutation(commentId, publicationId)

  return (
    <View testID={TEST_ID.PUBLICATION.SCREEN.COMMENT_PRAY_SCREEN} className="flex-1">
      <PrayScreen
        trackingSource={TRACKING_SOURCE.COMMENT}
        onPray={() => (responseId ? prayCommentResponseMutate(responseId) : prayCommentMutate(commentId))}
        onAmen={navigateBack}
        onClose={navigateBack}
        title={t('pray.comment.title', { userName: commentAuthor })}
      />
    </View>
  )
}
